<template>
<div>
  <v-row align="center">
    <v-overlay :value="loading" :opacity="1" :color="'#FFFFFF'">
      <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
    </v-overlay>
   

    <div class="col-md-12">      
      <span style="color:#777">Welcome to Lions Club District 306D9  | You're logged as a {{stringFormatting(role)}}</span> 
    </div>
    <div class="col-md-12 home-tabs-body">
      <ClubStats :count="count"></ClubStats>
    </div>
  </v-row>
  <MemberList @memberCount="memberCount($event)"></MemberList>
</div>
</template>

<script>
import ClubStats from "../components/dashboard/ClubStats.vue"; 
import MemberList from "../components/dashboard/MemberList.vue"; 
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Home",
  components: {
    ClubStats,
    MemberList
  },
  data: function() {
    return {
      statistics: [],
      count: 0,
      statsNotFound: require("@/assets/img/stats_empty.png"),
      role: localStorage.getItem('role') || null,
    };
  },
  computed: {
    ...mapGetters({     
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile"); 
  },

  watch: {
   
  },

  methods: {
     stringFormatting(str){
      return str.replace(/_/g, " ")
    },
    memberCount(value){
      this.count = value;
    }
    },   
  
};
</script>
